import { getColModelItem } from '../../../../../../services/lib/utils/helpers'
import { urlKey } from '../../../../../../services/api/api-urls'
import React from 'react'
import { InputNumber } from 'antd'

export const colKey: any = {
  rawMaterialId: urlKey.RawMaterial,
  suplierProductCode: 'suplierProductCode',
  unitPrice: 'unitPrice',
  priceBreak: 'priceBreak',
  description: 'description',   
  unit: 'unit',    
}

const keyInfosArray: any = () => {
  return [
    // {key: colKey.rawMaterialId, label: '', otherOptions: {type: 'select', isOverrideSelectionOptions: true, valueJoinArray: ['rawMaterialName', 'rawMaterialCode'], width: '20rem'}},
    { key: colKey.rawMaterialId, label: '',otherOptions: {type: 'select',width:'35rem',
          isNotCutting:true, isOverrideSelectionOptions: true, 
          valueJoinArray: ['rawMaterialName', 'rawMaterialCode']}},
    { key: colKey.suplierProductCode, label: '',otherOptions: {type: 'inputTextArea',isNotCutting:true,width:'14rem'} },
    { key: colKey.unitPrice, label: '',otherOptions: {type: 'inputTextArea',width:'5rem'}  },
    { key: colKey.priceBreak, label: '',otherOptions: {type: 'inputTextArea',width:'5rem'}  },
    { key: colKey.description, label: '',otherOptions: {type: 'inputTextArea',width:'10rem'}  },    
    { key: colKey.unit, label: '' ,otherOptions: {type: 'inputTextArea',width:'5rem'} },      
  ]
}

const colInfos: any = {
  rawMaterialId: {
    title: 'Raw Material',
    field: 'rawMaterialId',
    keywords: [
      colKey.rawMaterialId,
    ],
    render: (rowData:any) => rowData.rawMaterial ? `${rowData.rawMaterial?.rawMaterialName}(Code: ${rowData.rawMaterial?.rawMaterialCode})` : null,
  },
  suplierProductCode: {
    title: 'Suplier Product Code',
    field: 'suplierProductCode',
    keywords: [
      colKey.suplierProductCode,
    ]    
  }, 
  unit: {
    title: 'Unit',
    field: 'unit',
    keywords: [
      colKey.unit,
    ]    
  },   
  unitPrice: {
    title: 'Unit Price',
    field: 'unitPrice',
    keywords: [
      colKey.unitPrice,
    ]      
  },   
  priceBreak: {
    title: 'Price Break',
    field: 'priceBreak',
    keywords: [
      colKey.priceBreak,
    ]       
  }, 
  description: {
    title: 'Note',
    field: 'description',
    keywords: [
      colKey.description,
    ]          
  },    

}


const SupplierRawMaterialColumnModel = (): any => {
  let modelArr: any = [
    colInfos.rawMaterialId,
    colInfos.suplierProductCode,
    colInfos.unit,    
    colInfos.unitPrice,
    colInfos.priceBreak,
    colInfos.description,
  ]

  modelArr = modelArr.map((row: any) => getColModelItem(row, keyInfosArray))

  // unit_price 后端已改为3位小数:使用数字输入并限制3位小数,避免文本输入导致超精度被静默舍入
  modelArr = modelArr.map((row: any) => row.field === colKey.unitPrice ? {
    ...row,
    editComponent: (props: any) => (
      <InputNumber
        value={props.rowData.unitPrice}
        min={0}
        precision={3}
        step={0.001}
        style={{width: '100%'}}
        onChange={(value: any) => props.onRowDataChange({...props.rowData, unitPrice: value})}
      />
    )
  } : row)

  return modelArr
}

export default SupplierRawMaterialColumnModel
